import { connect } from 'react-redux'
import PrintButton from 'components/shared/PrintButton'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = (state) => ({
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(PrintButton)
